import { useContext } from 'react';
import {
    CalculatorInputFieldsKey,
    CalculatorInputOptions,
} from '../utils/CalculatorInputValue';
import { CalculatorFieldsContext } from '../contexts/CalculatorContext';
import { CalculatorCurrencyContext } from '../../../shared/contexts/CalculatorContext';

export function CalculatorRembursement(): JSX.Element | null {
    const [calculatorValue,] = useContext(CalculatorFieldsContext)!;
    const calculatorCurrencyContext = useContext(CalculatorCurrencyContext)!;
    const options = CalculatorInputOptions['I10_average_reimbursement_per_exams'];
    const currency = options?.displayCurrency ? calculatorCurrencyContext[0] : '';
    let selected = '';

    const getValue = (key: CalculatorInputFieldsKey): number => {
        const formatValueFunction = CalculatorInputOptions[key]?.formatValueFunction;
        const value = calculatorValue[key] || 0;
        return formatValueFunction?.(value) || value;
    }

    const keys: CalculatorInputFieldsKey[] = [
        'H13_examination_mix_hight_price_per_mix',
        'H14_examination_mix_medium_price_per_mix',
        'H15_examination_mix_low_price_per_mix'
    ];

    if (keys.reduce((prev, curr) => prev + (+(calculatorValue[curr] || 0)), 0) === 100) {
        selected = '' + (getValue('I8_average_number_of_procedures_per_day') * (getValue('H13_examination_mix_hight_price_per_mix') * getValue('E13_examination_mix_hight_price')
            + getValue('H14_examination_mix_medium_price_per_mix') * getValue('E14_examination_mix_medium_price')
            + getValue('H15_examination_mix_low_price_per_mix') * getValue('E15_examination_mix_low_price_per_mix')) / getValue('I8_average_number_of_procedures_per_day'));
    }

    return (
        <div className={(!selected ? 'error ' : '') + 'inputValue'}>
            <label htmlFor='rembursement'>Average reimbursement per exams</label>
            <div>{currency ? <span>{currency}</span> : ''}</div>
            <input id='rembursement'
                   readOnly
                   type="text"
                   value={selected}/>

            {!selected
                ? <small className="msg-error">Need mix to equal 100%</small>
                : ''
            }
        </div>
    );
}
